import * as i0 from '@angular/core';
import { Component, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { IDIconBase } from '@inera/ids-angular/common';
import '@inera/ids-core/components/icons/arrow/register';
class IDIconArrowComponent extends IDIconBase {
  static ɵfac = /* @__PURE__ */(() => {
    let ɵIDIconArrowComponent_BaseFactory;
    return function IDIconArrowComponent_Factory(__ngFactoryType__) {
      return (ɵIDIconArrowComponent_BaseFactory || (ɵIDIconArrowComponent_BaseFactory = i0.ɵɵgetInheritedFactory(IDIconArrowComponent)))(__ngFactoryType__ || IDIconArrowComponent);
    };
  })();
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: IDIconArrowComponent,
    selectors: [["id-icon-arrow"]],
    standalone: false,
    features: [i0.ɵɵInheritDefinitionFeature],
    decls: 2,
    vars: 0,
    consts: [["icon", ""]],
    template: function IDIconArrowComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelement(0, "ids-icon-arrow", null, 0);
      }
    },
    styles: ["[_nghost-%COMP%]{display:contents}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IDIconArrowComponent, [{
    type: Component,
    args: [{
      selector: 'id-icon-arrow',
      template: "<ids-icon-arrow #icon></ids-icon-arrow>",
      styles: [":host{display:contents}\n"]
    }]
  }], null, null);
})();
class IDIconArrowModule {
  static ɵfac = function IDIconArrowModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || IDIconArrowModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: IDIconArrowModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IDIconArrowModule, [{
    type: NgModule,
    args: [{
      declarations: [IDIconArrowComponent],
      exports: [IDIconArrowComponent],
      schemas: [CUSTOM_ELEMENTS_SCHEMA]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { IDIconArrowComponent, IDIconArrowModule };
